<template>
  <c-panel caption="お支払い方法">
    <template>
      <c-panel-content caption="カード番号">
        <span>{{user.payments.cardNo}}</span>
      </c-panel-content>

      <c-panel-content caption="有効期限">
        <div :class="expireColor">{{user.payments.expire | timeformat('m / Y')}}</div>

        <template v-if="expireStatus === 'warn'">
          <c-helper-text warn>有効期限が近づいています</c-helper-text>
        </template>

        <template v-else-if="expireStatus === 'expired'">
          <c-helper-text error>有効期限を過ぎています</c-helper-text>
        </template>
      </c-panel-content>
    </template>

    <template #actions>
      <c-panel-action
        caption="お支払い方法を変更する"
        :to="{ name: 'my/payment' }"
      />
    </template>
  </c-panel>
</template>

<script>
import base from '../base'
import * as time from '@/libs/time'

import CHelperText from '@/components/CHelperText'

export default {
  name: 'CHasPanel',
  mixins: [
    base
  ],
  components: {
    CHelperText
  },
  computed: {
    expireStatus () {
      const today = time.today()

      // 警告する日付: 1ヶ月前
      const warnDate = time.clone(today)
      warnDate.setMonth(warnDate.getMonth() + 1)

      // 期限切れとする日付: 今日
      const expiredDate = time.clone(today)

      // 日付文字列にする
      const warn = time.format('Y-m-d', warnDate)
      const expired = time.format('Y-m-d', expiredDate)

      if (this.user.payments.expire < expired) {
        return 'expired'
      } else if (this.user.payments.expire < warn) {
        return 'warn'
      }
      return 'ok'
    },

    expireColor () {
      switch (this.expireStatus) {
        case 'warn': return 'warning--text'
        case 'expired': return 'error--text'
      }
      return ''
    }
  }
}
</script>
